import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * TaskLabel — метка проекта (BE-5). Таблицы `task_module_labels` +
 * junction `task_module_task_labels` существуют; здесь — Zod SSOT.
 *
 * `color_token` — token-string (не hex/freeform): цвет резолвит FE через
 * design-tokens. Структурное поле, не user-facing freeform.
 */
export const TaskLabel = z.object({
  id: UuidString,
  entity_id: UuidString,
  /** project-scoped (nullable — на случай entity-global меток). */
  project_id: UuidString.nullable(),
  name: z.string().min(1).max(120),
  color_token: z.string().min(1).max(64),
});
export type TaskLabel = z.infer<typeof TaskLabel>;

/**
 * TaskLabelRef — denorm-подмножество метки на `Task.labels[]` (label-dots
 * без N+1 и без отдельного запроса справочника). Цвет — token-string.
 */
export const TaskLabelRef = z.object({
  id: UuidString,
  name: z.string().min(1).max(120),
  color_token: z.string().min(1).max(64),
});
export type TaskLabelRef = z.infer<typeof TaskLabelRef>;

/**
 * Ответ GET /task-module/labels — домен оси «метка» (BE-5).
 *
 * `usage_counts` приходит только при `with_usage=1` и считает НЕархивные задачи:
 * бейдж на заголовке колонки обязан совпадать с числом видимых в ней карточек.
 * Метки без задач присутствуют в labels[] со счётчиком 0 — иначе пустую колонку
 * (весь смысл справочника) построить не из чего.
 */
export const TaskLabelsListResponse = z.object({
  labels: z.array(TaskLabel),
  usage_counts: z.record(z.number().int().nonnegative()).optional(),
});
export type TaskLabelsListResponse = z.infer<typeof TaskLabelsListResponse>;
